import * as React from "react";
import {
    List,
    Datagrid,
    DateField,
    SelectField,
    ShowButton,
    CardActions,
    TextField,
    FunctionField
} from 'react-admin';
import ContractStatuses from "../helper/ContractStatuses";
import ContractEditButton from "../component/ContractEditButton"
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import ContractIdForm from "../helper/ContractIdForm";
import Filter from './Filter';

const ContractActions = ({
                                    bulkActions,
                                    basePath,
                                    currentSort,
                                    displayedFilters,
                                    exporter,
                                    filters,
                                    filterValues,
                                    onUnselectItems,
                                    resource,
                                    selectedIds,
                                    showFilter,
                                    total
                                }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
    </CardActions>
);

const CustomShowBtn = props => {
    return (<ShowButton {...props} label={props.record.contractNumber} />)
}

const Empty = () => {
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Мої договора - відсутні
            </Typography>
        </Box>
    );
};

const contractTypeTranslation = {
    REIMBURSEMENT: "Реімбурсація",
    CAPITATION: "Капітація"
}

const programs = {
    '63c1f32f-c8f4-4f5b-81a9-79b8452d6545': 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів',
    '8a11c513-e7a9-4800-9fb9-becb743e08c4': 'Імуносупресивні лікарські засоби',
    '14e19712-b443-4391-b0f7-aba8e8662459': 'Нецукровий діабет',
    'f217889f-736f-462c-8f8b-ed99edddb3be': 'Розлади психіки та поведінки',
    '9d94a21b-ec70-4b91-946a-981f4db8d2b9': 'Епілепсія',
    '0eececf1-aaf5-48fb-87e2-da44b7c49db2': 'Хвороба Паркінсона',
    '9a1364d7-2c61-4fe8-b889-ea788dbb7467': 'Інсуліни з доплатою',
    '9994be00-47b4-4969-800e-87a767751b47': 'Інсуліни безоплатно',
    'e9c6beeb-b19f-4b97-b42a-020c5c996c56': 'Інсуліни аналоги (з доплатою)',
    '7335a30e-61f2-42b0-9ed4-2afe847bba16': 'Інсуліни аналоги (безоплатно)',
    'cda113e4-b8dd-4ec4-a878-3d1c7eae49da': 'Інсуліни людські (флакони безоплатно)',
    '857588d8-9e12-4935-96c4-b08e95d19dce': 'Інсуліни людські (картриджи та шприцручки з доплатою)',
    '8efe29df-18bd-4d49-8995-c3f7e44d9e12': 'Інсуліни людські (картриджи та шприцручки безоплатно)',
    '0cefbce3-6dd2-45bd-b1e6-983fc055d5e0': 'Медичні вироби для визначення рівня глюкози в крові',
    '786ac2aa-af37-4bd0-b1f5-40a017bf2237': 'Постанова КМУ №1380 від 03.12.2024'
};

export const ContractList = (props) => (
    <List {...props}
          filters={<Filter />}
          bulkActionButtons={false}
          currentSort={{ field: 'createdAt', order: 'DESC' }}
          perPage={25}
          title="Договора"
          actions={<ContractActions />}
          className="list-styles"
          empty={<Empty />}
    >
        <Datagrid>
            <CustomShowBtn label="Номер контракту" style={{whiteSpace: 'nowrap'}}/>
            {/*<TextField label="Номер контракту" source="contractNumber" sortable={false} />*/}
            <FunctionField source="type" label="Тип договору" sortable={false} render={record => contractTypeTranslation[record.type]} />
            <SelectField label="Підтип договору" source="idForm" sortable={false} choices={ContractIdForm} />
            <FunctionField sortable={false} source="status" label="Мед. програма"
                           render={record => {
                               let result = [];

                               if (record.medicalPrograms) {
                                   for (let i = 0; i < record.medicalPrograms.length; i++) {
                                       result.push(programs[record.medicalPrograms[i]]);
                                   }
                               }

                               return result.length > 0 ? result.join(', ') : '';
                           }} />
            <SelectField label="Статус" source="status" sortable={false} choices={ContractStatuses} />
            <DateField style={{whiteSpace: 'nowrap'}} label="Дата початку" source="startDate" sortable={false} options={{ year: 'numeric', month: 'long', day: 'numeric' }} locales="uk-UA" />
            <DateField style={{whiteSpace: 'nowrap'}} label="Дата закінчення" source="endDate" sortable={false} options={{ year: 'numeric', month: 'long', day: 'numeric' }} locales="uk-UA" />
            <ContractEditButton label={"ОНОВИТИ ДАНІ"} variant="outlined" style={{whiteSpace: 'nowrap'}} />
            {/*<ContractProlongDialog />*/}
        </Datagrid>
    </List>
);

export default ContractList;
